export class GetAllAnswers {
    public static readonly type = '[KbItems] Get All Answers';
}

export class GetAnswer {
    public static readonly type = '[KbItems] Get an Answer';
    constructor(public question: string) {}
}
